module.exports = __webpack_public_path__ + "static/media/1s.bb3fe6c7.mp3";